import constant from '../../constant'

const initialState = { 
};

export function videoCommon (state = initialState, action) {
  switch (action.type) {
    case constant.VIDEO.VIDEO_TIME:
      return {
        ...state,
        lastTime: action.lastTime,
        currentTime: action.currentTime
      }
    case constant.VIDEO.SHARE_WECHAT_DIALOG:
      return {
        ...state,
        isShowShare: action.isShowShare
      }
    default:
      return state
  }

}